import React from "react";
import MessageContent from "./MessageContent";
import { PencilIcon } from "@heroicons/react/24/solid";

const SenderMessage = ({ message, onRevise }) => {
  const ava = message?.avatar?.length > 2 ? message?.avatar : "/molly.png";

  return (
    <div className="flex items-start gap-2">
      <div className="flex flex-col gap-2 items-end">
        <p className="m-0 p-0 text-sm font-medium leading-tight text-slate-700">
          {message.you ? "You" : message.authorName}
        </p>

        <div className="p-3 rounded-lg rounded-tr-none bg-primary text-white">
          <MessageContent message={message} />
        </div>

        <div className="flex items-start gap-6 justify-between w-full">
          {message.sender === "ChatBot" && (
            <button
              onClick={onRevise}
              type="button"
              className="rounded-lg bg-white px-2.5 py-1.5 text-sm font-light text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 flex items-center gap-2"
            >
              <PencilIcon className="size-4" />
              <span>Revise answer</span>
            </button>
          )}

          <p className="m-0 p-0 text-zinc-600 text-xs font-normal leading-none">
            {message.sentTime}
          </p>
        </div>
      </div>

      <div>
        <img
          src={ava}
          alt="Sender"
          className="object-cover size-10 rounded-full min-w-10"
        />
      </div>
    </div>
  );
};

export default SenderMessage;
